import React from "react";
import {
  GoogleMap,
  InfoWindow,
  Marker,
  Polygon,
  withGoogleMap,
} from "react-google-maps";
import MarkerView from "./MarkerView";
import { Grid } from "semantic-ui-react";

let mapOptions = {
  styles: [
    {
      featureType: "administrative",
      stylers: [{ saturation: -35 }, { lightness: 25 }],
    },
    {
      featureType: "landscape",
      stylers: [{ color: "#e3ddda" }, { visibility: "on" }],
    },
    { featureType: "poi", stylers: [{ saturation: -30 }, { lightness: 35 }] },
    {
      featureType: "poi.attraction",
      stylers: [{ saturation: -55 }, { lightness: 5 }],
    },
    { featureType: "poi.business", stylers: [{ saturation: -60 }] },
    {
      featureType: "poi.government",
      stylers: [{ saturation: -55 }, { lightness: 30 }],
    },
    {
      featureType: "poi.medical",
      stylers: [{ saturation: -55 }, { lightness: 30 }],
    },
    {
      featureType: "poi.park",
      elementType: "geometry.fill",
      stylers: [{ color: "#b3dfbe" }],
    },
    { featureType: "road", stylers: [{ saturation: -55 }, { lightness: 40 }] },
    { featureType: "transit", stylers: [{ visibility: "off" }] },
    {
      featureType: "water",
      elementType: "geometry.fill",
      stylers: [{ color: "#bccae1" }],
    },
  ],
  zoomControlOptions: {
    style: "SMALL",
  },
  mapTypeControlOptions: {
    style: "TINY",
  },
  streetViewControl: false,
  disableDoubleClickZoom: true,
  gestureHandling: "greedy",
  fullscreenControl: true,
  zoomControl: true,
  cameraControl: false,
};

export const GoogleMapExample = withGoogleMap((props) => {
  return (
    <>
      {props.data.props.addressInfo.state.lat != "" && (
        <GoogleMap
          options={mapOptions}
          defaultCenter={{
            lat: props.data.props.addressInfo.state.lat,
            lng: props.data.props.addressInfo.state.lng,
          }}
          //zoom={props.data.props.addressInfo.state.zoom}
          onDragEnd={props.onDragEnd}
          onZoomChanged={props.onZoomChanged}
          defaultZoom={props.data.props.addressInfo.state.zoom}
          editable={true}
          onPolygonComplete={(polygon) => {
            for (let point of polygon.getPath().getArray()) {
              GeoJSON.geometry.coordinates.push([point.lng(), point.lat()]);
            }
          }}
        >
          {props.data.state.polyGon.length !== 0 && (
            <Polygon
              paths={props.data.state.polyGon}
              options={{
                fillColor: "#5000ff",
                strokeColor: "#5000ff",
                strokeWeight: 1,
              }}
            />
          )}
          <MarkerView
            markers={props.data.state.markers}
            info={props.data.props.addressInfo}
            data={props.data}
          />
          {/*{(props.data.state.boolWindow)
          ? <Marker
              key={12586}
              icon={''}
              visible={false}
              position={{'lat': props.data.state.boolWindow.lat, 'lng': props.data.state.boolWindow.lng}}
            >
              <div>
                <InfoWindow>
                  <Grid>
                    <Grid.Column textAlign='center'>
                      <div>{props.data.state.boolWindow.name}</div>
                      <div>{props.data.state.boolWindow.vl}</div>
                    </Grid.Column>
                  </Grid>
                </InfoWindow>
              </div>
            </Marker>
          : null
        }*/}
        </GoogleMap>
      )}
    </>
  );
});
